export default {
  "content": "<path d=\"M9.207 4.207L6.414 7H15a6.5 6.5 0 010 13h-3.5v-2H15a4.5 4.5 0 000-9H6.414l2.793 2.793-1.414 1.414-4.5-4.5a1 1 0 010-1.414l4.5-4.5 1.414 1.414z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};